export const svg = [
  {
    icon: "React",
    src: require('./react.svg'),
  },
  {
    icon: "redux",
    src: require('./Redux.png'),
  },
  {
    icon: "nodejs",
    src: require('./nodejs.svg'),
  },
  {
    icon: "Django",
    src: require('./django.svg'),
  },
  {
    icon: "Redis",
    src: require('./redis.svg'),
  },
  {
    icon: "Javascript",
    src: require('./js.svg'),
  },
  {
    icon: "postgres",
    src: require('./postgres.svg'),
  },
  {
    icon: "go",
    src: require('./go.svg'),
  },
  {
    icon: "mongo",
    src: require('./mongo.svg'),
  },
  {
    icon: "cpp",
    src: require('./cpp.svg'),
  },
  {
    icon: "git",
    src: require('./git.svg'),
  },
  {
    icon: "webrtc",
    src: require('./webrtc.svg'),
  },
];